var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "blue",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39156 6.62058C4.8358 9.20399 3.05792 10.4957 2.35965 12.4037C2.30363 12.5568 2.25325 12.7118 2.2086 12.8686C1.65201 14.8227 2.3311 16.9127 3.68927 21.0927C5.04745 25.2728 5.72654 27.3628 7.3254 28.6165C7.45366 28.7171 7.58557 28.8129 7.72085 28.9038C9.40728 30.037 11.6049 30.037 16 30.037C20.3952 30.037 22.5927 30.037 24.2792 28.9038C24.4144 28.8129 24.5464 28.7171 24.6746 28.6165C26.2735 27.3628 26.9526 25.2728 28.3107 21.0927C29.6689 16.9127 30.348 14.8227 29.7914 12.8686C29.7468 12.7118 29.6964 12.5568 29.6404 12.4037C28.9421 10.4957 27.1642 9.20399 23.6085 6.6206C20.0527 4.03719 18.2748 2.74547 16.2444 2.67099C16.0815 2.66501 15.9185 2.66501 15.7556 2.67099C13.7252 2.74547 11.9473 4.03718 8.39156 6.62058ZM13.3333 22.7594C12.781 22.7594 12.3333 23.2071 12.3333 23.7594C12.3333 24.3117 12.781 24.7594 13.3333 24.7594H18.6667C19.219 24.7594 19.6667 24.3117 19.6667 23.7594C19.6667 23.2071 19.219 22.7594 18.6667 22.7594H13.3333Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home_icon.879ad36032237913d0809bd87acc9232.svg";
export { ForwardRef as ReactComponent };